import { selectProcedureTypeById } from "@overmap-ai/core"
import { createFileRoute, notFound, Outlet } from "@tanstack/react-router"
import { appStore } from "src/store"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId",
)({
	component: Outlet,
	loader: ({ params }) => {
		const procedureType = selectProcedureTypeById(params.procedureTypeId)(appStore.getState())
		if (!procedureType) throw notFound()
		return procedureType
	},
})
